<ms-my-bets-pair-game-scoreboard [vm]="vm">
    <ms-my-bets-scoreboard-players-pair players [vm]="vm"></ms-my-bets-scoreboard-players-pair>
    <ms-my-bets-penalty-shootout-scoreboard-stats
        class="my-bets-penalty-shootout-scoreboard-stats"
        stats
        [vm]="vm.stats"></ms-my-bets-penalty-shootout-scoreboard-stats>
</ms-my-bets-pair-game-scoreboard>
